<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<h1 class="title">GUILT TRIP</h1>
<p class="subtitle">A Lina Townend Mystery</p>
<h2 class="author">Judith Cutler</h2>
<div class="logo"><span class="center"><img alt="Logo Missing" class="imgsize" src="OEBPS/images/logo.jpg"/></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4b763d01